import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=5d6d14bc&"
import script from "./resetPassword.vue?vue&type=script&lang=ts&"
export * from "./resetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports